import { render, staticRenderFns } from "./Block6Item.vue?vue&type=template&id=19d15f2c&scoped=true&"
import script from "./Block6Item.vue?vue&type=script&lang=js&"
export * from "./Block6Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d15f2c",
  null
  
)

export default component.exports